import image11 from '../../../assets/images/ecommerce/jpg/7.jpg';
import image12 from '../../../assets/images/ecommerce/jpg/12.jpg';
import image13 from '../../../assets/images/ecommerce/jpg/11.jpg';
import image14 from '../../../assets/images/ecommerce/jpg/13.jpg';

export const Productdetailsdata1 = [
    { id: 1, image: image11, category: 'Furniture', title: 'Table Plant', originalPrice: '999', discountedPrice: '799', },
    { id: 2, image: image12, category: 'Fashion', title: 'Speed Watch', originalPrice: '999', discountedPrice: '799', },
    { id: 3, image: image13, category: 'Kitchen set', title: 'Coffee Cup', originalPrice: '999', discountedPrice: '799', },
    { id: 4, image: image14, category: 'Plants', title: 'A Cactus Plant', originalPrice: '999', discountedPrice: '799', },
]